import * as React from 'react'
import { SVGProps } from 'react'
const SvgCheckRounded = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 51 37" xmlSpace="preserve" {...props}>
    <path d="M16.7 36.5c-.4 0-.8-.2-1.1-.5L.9 21c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l13.6 13.9L47.9 1c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1L17.8 36c-.3.3-.7.5-1.1.5z" />
  </svg>
)
export default SvgCheckRounded
